import $ from "jquery"

$('.js-faq-item-heading').each(function() {
    $(this).on('click', function() {
        $('.faq__item').removeClass('faq__item--active');
        $(this).closest('.faq__item').toggleClass('faq__item--active');
    });
});